/** @module csi/view/ToolbarPopupMenuItem */
define([
	"dojo/_base/declare",
	"dojo/dom-class",
	"dijit/PopupMenuItem",
	"./ToolbarPlugin"
], function(declare,domClass,PopupMenuItem,ToolbarPlugin) {

	return declare([PopupMenuItem, ToolbarPlugin], {
		/**
		 * Add class to menu item while child is open
		 * @param {Object} params
		 * @param {boolean} focus
		 */
		_openPopup: function(params, focus) {
			domClass.add(this.domNode, "csi-popup-menu-selected");
			this.inherited(arguments);
		},

		/**
		 * Remove class from above
		 */
		_closePopup: function() {
			domClass.remove(this.domNode, "csi-popup-menu-selected");
			this.inherited(arguments);
		}
	});
});